import React, { useState } from "react";
import { Box, Stack, Typography, Button } from "@mui/material";

export const FileDropZone = ({
  files,
  onFilesChange,
  multipleFiles = false,
  acceptedFormats = ".pdf,.doc,.docx",
  disabled = false,
}) => {
  const [dragging, setDragging] = useState(false);
  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    if (disabled) return;
    const incoming = Array.from(event.dataTransfer.files || []);
    onFilesChange(incoming);
  };

  const handleSelectFiles = (event) => {
    if (disabled) return;
    const incoming = Array.from(event.target.files || []);
    onFilesChange(incoming);
  };

  return (
    <Box
      onDrop={handleDrop}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      sx={{
        mt: 3,
        border: "2px dashed",
        borderColor: dragging ? "divider" : "primary.main",
        borderRadius: 2,
        p: 4,
        textAlign: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor: dragging ? "action.hover" : "transparent",
        transition: "background-color 0.2s",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="subtitle1" color="text.secondary">
          Choose files or drag and drop here
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {acceptedFormats.includes(".doc")
            ? "PDF or doc/docx formats"
            : "PDF format only"}
        </Typography>
        <Button
          variant="contained"
          component="label"
          sx={{ textTransform: "none" }}
          disabled={disabled}
        >
          {multipleFiles ? "Choose Files" : "Choose File"}
          <input
            type="file"
            hidden
            multiple={multipleFiles}
            accept={acceptedFormats}
            onChange={handleSelectFiles}
          />
        </Button>
        {files.length > 0 && (
          <Typography variant="caption" color="text.secondary">
            Selected: {files.length} file(s)
          </Typography>
        )}
      </Stack>
    </Box>
  );
};
